module.exports = __webpack_public_path__ + "static/img/zjsq_icon.bfe8269.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zjsq_icon.png
// module id = 8lSn
// module chunks = 52